import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { formContentContainer, loaderOverlay } from "../../Style/loaderOverly";
import { AvForm } from "availity-reactstrap-validation";
import { useNavigate, useParams } from "react-router-dom";
import { createPageData, outwardFormData } from "./CommissioningListFile";
import { LoaderCreatePage } from "../Loader/Loader";
import {
  apiUrl,
  baseURL,
  DownloadPDFData,
  getRecords,
  imageURL,
  formatNumber,
  formatDate,
} from "../../services/api.service";
import CommissioningPDF from "./CommissioningPDF/CommissioningPDF";

const CommissioningListView = () => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, headerName, getEndpoint } = createPageData();
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(outwardFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [groupedItems, setGroupedItems] = useState({});
  let serialNumber = 1;

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData[0];

      const updatedListDetails = data?.commissioning_details?.map((item) => ({
        item_id: item?.item_id,
        buy_item_id: item?.buy_item_id,
        item_code: item?.installation_obj.item.item_code,
        buy_item_code: item?.installation_obj.buyItem.item_code,
        description: item?.installation_obj.item.description,
        uom: item.installation_obj?.buyItem?.uom?.uom_name,
        make_item_desc: item?.installation_obj?.item?.description,
        make_item_uom: item.installation_obj?.item.uom?.uom_name,
        remark: item?.remark,
        date: item?.date,
        installed_qty: item?.installation_obj?.already_installed_qty,
        type: item?.is_make_item ? 1 : 2,
        is_make_item: item?.is_make_item,
        is_active: item?.is_active,
        is_check: item.is_check,
        id: item.id,
        make_buy_name: item?.is_make_item
          ? item?.buyItem?.item_code + " (" + item?.makeItem?.item_code + ")"
          : item?.buyItem?.item_code,
        installation_obj: item?.installation_obj,
      }));

      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
          commissioning_details: updatedListDetails,
        },
      }));
    }
  }, [fetchedData]);
  const getEditData = async (Id) => {
    try {
      const projectId = JSON.parse(localStorage?.getItem("projectID"));
      const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;
      const payload = {
        modelName: "commissionings",
        modifyResponse: true,
        getCommissioningDetails: true,
        whereCondition: {
          project_id: projectId,
          id: id,
        },
        relations: [
          {
            module: "installations",
            moduleAs: "installation",
          },
          {
            module: "user_masters",
            moduleAs: "creator",
          },
          {
            module: "installation_commissioning_list_masters",
            moduleAs: "commissioningForm",
          },
        ],
      };
      const responseData = await getRecords(payload, "/listCommissioning");

      if (responseData?.code == 1) {
        const data = responseData?.data;
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value);
  };

  // Filter items based on search query
  const filteredItems =
    formData?.inputData?.commissioning_details?.filter(
      (item) =>
        item?.item_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.buy_item_code?.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  useEffect(() => {
    if (!filteredItems || filteredItems.length === 0) return;

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Commissioning List Details</h5>
                          <Button
                            style={{ marginLeft: "10px" }}
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                          <Button
                            color="success"
                            className="waves-effect waves-light me-1 back-button ml-2"
                            style={{ borderRadius: "50%" }}
                            onClick={() => {
                              DownloadPDFData("CommissioningDetails.pdf");
                            }}
                          >
                            <i class="fas fa-download"></i>
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Commissioning No: </strong>
                                {formData?.inputData?.commissioning_no ? (
                                  <span>
                                    {formData?.inputData?.commissioning_no}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Commissioning Date: </strong>
                                {formData?.inputData?.createdAt ? (
                                  <span>
                                    {formatDate(formData?.inputData?.createdAt)}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>
                            <Col md="6" className="p-3">
                              <p>
                                <strong>Commissioning Person: </strong>
                                {formData?.inputData?.creator ? (
                                  <span>
                                    {formData?.inputData?.creator?.first_name +
                                      " " +
                                      formData?.inputData?.creator?.last_name}
                                  </span>
                                ) : (
                                  "-"
                                )}
                              </p>
                              <p>
                                <strong>Commissioning Status: </strong>
                                {(() => {
                                  const installation =
                                    formData?.inputData?.installation;

                                  if (installation?.is_commissioning_paid) {
                                    return <span>Commissioning Paid</span>;
                                  } else if (
                                    installation?.is_commissioning_claimed
                                  ) {
                                    return <span>Commissioning Claimed</span>;
                                  } else if (
                                    installation?.status ===
                                    "commissioning_completed"
                                  ) {
                                    return <span>Commissioning Completed</span>;
                                  } else {
                                    return <span>N/A</span>;
                                  }
                                })()}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <Row className="mt-4">
                        <div className="item-list-container">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="h-6-heading">Item Details</h6>
                            <div className="app-search d-flex d-lg-inline mt-0 p-0">
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control ps-5"
                                  placeholder="Search by item code..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  style={{
                                    width: "13rem",
                                    padding: "8px 15px",
                                    borderRadius: "8px",
                                    borderColor: "#D2D2D2",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "none",
                                    marginRight: "0.5rem",
                                  }}
                                />
                                <span className="ri-search-line"></span>
                              </div>
                            </div>
                          </div>

                          <table className="table table-hover mt-2">
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                backgroundColor: "#8AC1E8",
                                zIndex: 1,
                              }}
                            >
                              <tr style={{ borderBottom: "1px solid black" }}>
                                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                                <th
                                  style={{
                                    width: "%",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Item Code
                                </th>

                                <th
                                  style={{
                                    width: "18%",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Item Description
                                </th>
                                <th
                                  style={{
                                    width: "15%",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  UOM
                                </th>

                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    width: "15%",
                                  }}
                                >
                                  Installed Qty
                                </th>
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    width: "15%",
                                  }}
                                >
                                  Remark
                                </th>
                                <th
                                  style={{
                                    whiteSpace: "nowrap",
                                    width: "15%",
                                  }}
                                >
                                  Date
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.values(groupedItems).length === 0 ? (
                                <tr>
                                  <td
                                    colSpan="10"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available.
                                  </td>
                                </tr>
                              ) : (
                                Object.values(groupedItems)?.map(
                                  (group, index) => (
                                    <React.Fragment
                                      key={group.makeItem.unique_id}
                                    >
                                      {group.makeItem.is_make_item && (
                                        <tr
                                          style={{
                                            fontWeight: "bold",
                                            backgroundColor: "#f0f8ff",
                                          }}
                                        >
                                          <td>{serialNumber++}</td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "180px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "normal",
                                              }}
                                              title={
                                                group.makeItem.item_code ||
                                                "N/A"
                                              }
                                            >
                                              {group.makeItem.item_code ||
                                                "N/A"}
                                            </div>
                                          </td>
                                          {/* <td>{"-"}</td> */}
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "180px",
                                            }}
                                          >
                                            {" "}
                                            <div
                                              style={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "normal",
                                              }}
                                              title={
                                                group?.makeItem
                                                  ?.make_item_desc || "N/A"
                                              }
                                            >
                                              {group?.makeItem
                                                ?.make_item_desc || "N/A"}
                                            </div>
                                          </td>
                                          <td
                                            style={{
                                              paddingLeft: "10px",
                                              paddingRight: "2px",
                                              minWidth: "100px",
                                            }}
                                          >
                                            {" "}
                                            {group?.makeItem?.make_item_uom ||
                                              "N/A"}
                                          </td>
                                          <td>{"-"}</td>
                                          <td>{"-"}</td>
                                          <td>{"-"}</td>
                                        </tr>
                                      )}

                                      {group?.buyItems
                                        ?.filter((item) => item.is_make_item)
                                        ?.map((row, subIndex) => (
                                          <tr
                                            key={row.unique_id}
                                            style={{
                                              borderBottom: "1px solid #ccc",
                                            }}
                                          >
                                            <td>{`${serialNumber - 1}.${
                                              subIndex + 1
                                            }`}</td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  row?.buy_item_code || "N/A"
                                                }
                                              >
                                                {row?.buy_item_code || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  row?.description || "N/A"
                                                }
                                              >
                                                {row?.description || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {row?.uom || "N/A"}
                                            </td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "115px",
                                              }}
                                            >
                                              {formatNumber(
                                                row?.installed_qty || 0
                                              )}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "115px",
                                              }}
                                            >
                                              {row?.remark || "N/A"}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "115px",
                                              }}
                                            >
                                              {formatDate(row?.date) || "N/A"}
                                            </td>
                                          </tr>
                                        ))}
                                      {group?.buyItems
                                        ?.filter(
                                          (item) => item.is_make_item == false
                                        )
                                        ?.map((row, subIndex) => (
                                          <tr
                                            key={row.unique_id}
                                            style={{
                                              borderBottom: "1px solid #ccc",
                                            }}
                                          >
                                            <td>{serialNumber++}</td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={row?.item_code || "N/A"}
                                              >
                                                {row?.item_code || "N/A"}
                                              </div>
                                            </td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "180px",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "-webkit-box",
                                                  WebkitBoxOrient: "vertical",
                                                  WebkitLineClamp: 2,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "normal",
                                                }}
                                                title={
                                                  row?.description || "N/A"
                                                }
                                              >
                                                {row?.description || "N/A"}
                                              </div>
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {row?.uom || "N/A"}
                                            </td>

                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {formatNumber(row?.installed_qty)}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {row?.remark || "N/A"}
                                            </td>
                                            <td
                                              style={{
                                                paddingLeft: "10px",
                                                paddingRight: "2px",
                                                minWidth: "100px",
                                              }}
                                            >
                                              {formatDate(row?.date) || "N/A"}
                                            </td>
                                          </tr>
                                        ))}
                                    </React.Fragment>
                                  )
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </Row>
                      <Row className="mt-4">
                        <div className="payment-details-card p-3">
                          <h6 className="h-6-heading">Images</h6>
                          <div className="row mt-2">
                            {formData?.inputData &&
                            formData?.inputData?.file?.length > 0 ? (
                              formData.inputData.file.map((item, index) => (
                                <div className="col-md-6 col-lg-2" key={index}>
                                  <div
                                    className="card"
                                    style={{
                                      marginBottom: "20px",
                                      borderRadius: "5px",
                                      border: "1px solid #ddd",
                                      overflow: "hidden",
                                      transition:
                                        "transform 0.3s ease, box-shadow 0.3s ease",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1.05)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1)")
                                    }
                                  >
                                    <div
                                      className="card-body"
                                      style={{
                                        padding: "16px",
                                        backgroundColor: "#fff",
                                        textAlign: "center",
                                      }}
                                    >
                                      <img
                                        onClick={() =>
                                          handleImageClick(
                                            baseURL + item.filePath
                                          )
                                        }
                                        src={baseURL + "/" + item.filePath}
                                        alt="Installation Image"
                                        style={{
                                          width: "100%",
                                          height: "150px",
                                          borderRadius: "5px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="col-12 text-center">
                                <div
                                  style={{
                                    padding: "20px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    color: "#6c757d",
                                  }}
                                >
                                  No data available.
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "none",
                            position: "absolute",
                            left: "-9999px",
                          }}
                          id="pdfContent"
                        >
                          <CommissioningPDF
                            data={formData.inputData}
                            groupedItems={groupedItems}
                          />
                        </div>
                      </Row>
                    </AvForm>
                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CommissioningListView;
